import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import bookings743b13 from './bookings'
import dailyV1F73602 from './daily-v1'
import dailyA957a5 from './daily'
/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::bookings
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:30
* @route '/reports/bookings'
*/
export const bookings = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bookings.url(options),
    method: 'get',
})

bookings.definition = {
    methods: ["get","head"],
    url: '/reports/bookings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::bookings
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:30
* @route '/reports/bookings'
*/
bookings.url = (options?: RouteQueryOptions) => {
    return bookings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::bookings
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:30
* @route '/reports/bookings'
*/
bookings.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: bookings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::bookings
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:30
* @route '/reports/bookings'
*/
bookings.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: bookings.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::bookings
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:30
* @route '/reports/bookings'
*/
const bookingsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bookings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::bookings
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:30
* @route '/reports/bookings'
*/
bookingsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bookings.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\BookingReportController::bookings
* @see app/Http/Controllers/Admin/Reports/BookingReportController.php:30
* @route '/reports/bookings'
*/
bookingsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: bookings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

bookings.form = bookingsForm

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::dailyV1
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:29
* @route '/reports/daily-v1'
*/
export const dailyV1 = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dailyV1.url(options),
    method: 'get',
})

dailyV1.definition = {
    methods: ["get","head"],
    url: '/reports/daily-v1',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::dailyV1
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:29
* @route '/reports/daily-v1'
*/
dailyV1.url = (options?: RouteQueryOptions) => {
    return dailyV1.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::dailyV1
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:29
* @route '/reports/daily-v1'
*/
dailyV1.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dailyV1.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::dailyV1
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:29
* @route '/reports/daily-v1'
*/
dailyV1.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dailyV1.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::dailyV1
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:29
* @route '/reports/daily-v1'
*/
const dailyV1Form = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dailyV1.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::dailyV1
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:29
* @route '/reports/daily-v1'
*/
dailyV1Form.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dailyV1.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::dailyV1
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:29
* @route '/reports/daily-v1'
*/
dailyV1Form.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dailyV1.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dailyV1.form = dailyV1Form

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::daily
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:34
* @route '/reports/daily'
*/
export const daily = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: daily.url(options),
    method: 'get',
})

daily.definition = {
    methods: ["get","head"],
    url: '/reports/daily',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::daily
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:34
* @route '/reports/daily'
*/
daily.url = (options?: RouteQueryOptions) => {
    return daily.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::daily
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:34
* @route '/reports/daily'
*/
daily.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: daily.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::daily
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:34
* @route '/reports/daily'
*/
daily.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: daily.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::daily
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:34
* @route '/reports/daily'
*/
const dailyForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: daily.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::daily
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:34
* @route '/reports/daily'
*/
dailyForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: daily.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::daily
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:34
* @route '/reports/daily'
*/
dailyForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: daily.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

daily.form = dailyForm

const reports = {
    bookings: Object.assign(bookings, bookings743b13),
    dailyV1: Object.assign(dailyV1, dailyV1F73602),
    daily: Object.assign(daily, dailyA957a5),
}

export default reports